import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function GreyhoundRacingNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Greyhounds",
    links: [
      { href: "/greyhounds",              text: "News",       isIndex: true },
      { href: "/greyhounds/racecards",    text: "Racecards" },
      { href: "/greyhounds/fast-results", text: "Fast Results" },
      { href: "/greyhounds/results",      text: "Full Results" }
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

GreyhoundRacingNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default GreyhoundRacingNav



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/nav/GreyhoundRacingNav.js